import React from "react";
import { Popover, Button } from "antd";
import { FaInfoCircle } from "react-icons/fa";

const PriceFareMobileViewTripJack = ({
    loading,
    totalBookingPrice,
    flightDetails,
    totalAmount,
    mealTotalAmount,
    open,
    handleOpenChange,
    handleProceed,
    handleConfirmAndPay,
    addonsCompHide,
    setConvenienceChargeTotalFareModal,
    mealTotalAmountRetrun,
    totalAmountBaggageReturn,
    applyDiscountShow,
    discountAmountOffer,
    totalAfterDiscount,
    isFormValid,
    totalSeatPrice,
    totalSeatsPriceReturn
}) => {
    return (

        <div className="footer-price d-md-none">
            <div className="footer-price-content">
                <div>
                    {loading ? (
                        <div className="d-flex align-items-center gap-2">
                            <div className="spinner ms-2"></div>
                        </div>
                    ) : (
                        <>
                            <h2 className="fw-bold d-flex align-items-center gap-2">
                                {!applyDiscountShow ? (
                                    <>₹{Math.round(totalBookingPrice)}</>) : (
                                    <>₹{Math.round(totalAfterDiscount)}</>
                                )}
                                <Popover
                                    content={
                                        <div>
                                            <ul className="price-details list-unstyled">
                                                {flightDetails?.searchQuery?.paxInfo?.ADULT > 0 && (
                                                    <li className="d-flex justify-content-between">
                                                        <div> <span>{flightDetails.searchQuery.paxInfo.ADULT === 1 ? "Adult" : "Adults"} </span>({flightDetails.searchQuery.paxInfo.ADULT} X ₹{flightDetails?.priceBreakup?.ADULT_BF || 0})</div>
                                                        <span>₹{(flightDetails?.priceBreakup?.ADULT_BF || 0) * flightDetails.searchQuery.paxInfo.ADULT}</span>
                                                    </li>
                                                )}

                                                {flightDetails?.searchQuery?.paxInfo?.CHILD > 0 && (
                                                    <li className="d-flex justify-content-between">
                                                        <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Child" : "Children"}</span> ({flightDetails.searchQuery.paxInfo.CHILD} X ₹{flightDetails?.priceBreakup?.CHILD_BF || 0})</div>
                                                        <span>₹{(flightDetails?.priceBreakup?.CHILD_BF || 0) * flightDetails.searchQuery.paxInfo.CHILD}</span>
                                                    </li>
                                                )}

                                                {flightDetails?.searchQuery?.paxInfo?.INFANT > 0 && (
                                                    <li className="d-flex justify-content-between">
                                                        <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Infant" : "Infants"} </span>({flightDetails.searchQuery.paxInfo.INFANT} X ₹{flightDetails?.priceBreakup?.INFANT_BF || 0})</div>
                                                        <span>₹{(flightDetails?.priceBreakup?.INFANT_BF || 0) * flightDetails.searchQuery.paxInfo.INFANT}</span>
                                                    </li>
                                                )}

                                                <li className="d-flex justify-content-between">
                                                    <span>Fee & Surcharges</span>
                                                    <span className="ms-2">₹{flightDetails?.priceBreakup?.ServiceTax || 0}</span>
                                                </li>

                                                {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
                                                    <li className='d-flex justify-content-between'>
                                                        Meal  <span>₹{mealTotalAmount + mealTotalAmountRetrun}</span>
                                                    </li>
                                                )}

                                                {(totalAmount > 0 || totalAmountBaggageReturn > 0) && (
                                                    <li className='d-flex justify-content-between'>
                                                        Baggage <span>₹{totalAmount + totalAmountBaggageReturn}</span>
                                                    </li>
                                                )}

                                                {(totalSeatPrice > 0 || totalSeatsPriceReturn > 0) && (
                                                    <li className='d-flex justify-content-between'>
                                                        Seats <span>₹{totalSeatPrice + totalSeatsPriceReturn}</span>
                                                    </li>
                                                )}


                                                {applyDiscountShow && discountAmountOffer > 0 && (
                                                    <li className="d-flex justify-content-between">
                                                        Discount <span className="text-danger">₹{Math.round(discountAmountOffer)}</span>
                                                    </li>
                                                )}

                                            </ul>
                                            <div className="text-center mt-2 bg-light-success p-1 rounded">

                                                {!applyDiscountShow ? (
                                                    <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalBookingPrice)}</span></h3></>) : (
                                                    <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalAfterDiscount)}</span></h3></>
                                                )}
                                            </div>
                                        </div>
                                    }
                                    title="Payment Detail"
                                    trigger="click"
                                    open={open}
                                    onOpenChange={handleOpenChange}
                                    className="booking-filter"
                                >
                                    <span>
                                        <FaInfoCircle />
                                    </span>
                                </Popover>
                            </h2>
                            <p>
                                For {" "}
                                {(() => {
                                    const adults = flightDetails?.searchQuery?.paxInfo?.ADULT || 0;
                                    const children = flightDetails?.searchQuery?.paxInfo?.CHILD || 0;
                                    const infants = flightDetails?.searchQuery?.paxInfo?.INFANT || 0;
                                    return `${adults + children + infants}`;
                                })()} {" "}
                                Travellers
                            </p>
                        </>
                    )}
                </div>
                {!addonsCompHide ?
                    <Button
                        style={{ height: "38px" }}
                        className='btn btn-light menu-block fw-bold rounded'
                        onClick={() => handleProceed()}
                        aria-label="handle proceed">
                        {isFormValid ? "Continue" : "Proceed"}
                    </Button>
                    :
                    <Button
                        style={{ height: "38px" }}
                        className='btn btn-light menu-block fw-bold rounded'
                        onClick={() => setConvenienceChargeTotalFareModal(true)}
                        aria-label="handle proceed">
                        Continue To Pay
                    </Button>}
            </div>
        </div>
    );
};

export default PriceFareMobileViewTripJack;
